<dx-pie-chart
  id="time-pie-chart"
  palette="bright"
  [size]="{width: width || 320,  height: height || 300}"
  [dataSource]="data">
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-title [text]="title">
    <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
  </dxo-title>
  <dxi-value-axis [visible]="false"> </dxi-value-axis>
  <dxi-series
    argumentField="name"
    valueField="duration">
    <dxo-label
      [visible]="true"
      position="columns"
      [customizeText]="customizeLabel">
      <dxo-font [size]="12"></dxo-font>
      <dxo-connector
        [visible]="true"
        [width]="0.5"></dxo-connector>
    </dxo-label>
  </dxi-series>
</dx-pie-chart>
